export default __webpack_public_path__ + "static/media/logo.2805f8e8.svg";